

export default {
    path: 'dl/:stage?',
    name: 'project-deliverables',
    props: true,
    component: () => import("@/components/temp/Temp"),
}